<template>
  <form @submit.prevent>
    <CModal
        :title.sync="title"
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        
        <strong > Kids Information </strong>
            <CRow class="mb-3" v-if="!loading_info">
              <CCol lg="6">
                <label> {{ "Barcode: " + form.barcode }} </label>
              </CCol>
            </CRow>
            <hr>  
            <CRow class="mt-3" v-if="!loading_info">
              <CCol >
                <label> {{ "Name: " + form.firstname + ' ' + form.lastname }} </label>
              </CCol>
            </CRow>
            <hr>
            <CRow class="mt-2" v-if="!loading_info">
              <CCol >
                <label> {{ "Date Of Birth: " + form.dob  }} </label>
              </CCol>
            </CRow>   
            <hr>  
            <CRow class="mb-3" v-if="!loading_info">
              <CCol lg="6">
                <label> {{ "Sex: " + form.sex + ' ' }} </label>
              </CCol>
            </CRow>
            
            <CRow v-else class="center"><b-spinner variant="primary" label="Spinning"><br></b-spinner></CRow>
            <hr>
            <strong > Parents Information </strong>
             <CRow  class="mt-3" v-if="!loading_parent">    
              <CCol>
                <label> {{ "Dad: " + dad  }} </label>
              </CCol>
              <CCol>
                <label> {{ "Mom: " + mom  }} </label>
              </CCol>
            </CRow>
            <CRow v-else class="center"><b-spinner variant="primary" label="Spinning"><br></b-spinner></CRow>
            
            <hr>
            <strong > Class Information </strong>
             <CRow class="mt-3" >
              <CCol>
                <label> {{ "Class: " + form.class_id  }} </label>
              </CCol>
            </CRow>
            <CCol>
                     <CInput v-model="form.ikid_id" hidden  />
                  </CCol>
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton type="submit" v-on:click.prevent="queue()"  variant="outline" color="info">Set Queue</CButton>
      </template>
    </CModal>
  </form>
</template>

<script>
import moment from 'moment';
import EventBus from '@/eventBus';
import { ModelSelect } from 'vue-search-select'
import ikid from '@/services/ikid'



export default {
name: 'keperluanmodal',
components: {ModelSelect },
  data () {
    return {
      show: false,
      loading_info: false,
      loading_parent: false,
      loading_class: false,
      title: '',
      mode: '',
      options_class: [],
      options_dad: [],
      options_mom: [],
      dad_id:'',
      mom_id:'',
      dad:'',
      mom:'',
      form:{
        ikid_id:'',
      },
      options: ['Male', 'Female'],
      radioNames: ['Gender',]
    }
  },
  mounted(){
    
  },
  created () {
    var self = this;
    EventBus.$on('OPEN_MODAL_IKID_QUEUE', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.loading_info = true;
        this.getClass() //GET SERVICE TYPE ALL FOR DROPDOWNLIST
        this.getParent() //GET PARENT ACTIVE

        ikid.getIkidbyID(params.data)
        .then(res => {
          self.form.id = res.data.id;
          self.form.uuid = res.data.uuid;
          self.form.firstname = res.data.firstname;
          self.form.lastname = res.data.lastname;
          self.form.dob = res.data.dob;
          self.form.class_id = res.data.ikid_class.name;
          self.form.sex = res.data.sex;
          self.form.people_id = params.data;
          self.form.ikid_id = res.data.id;
          self.form.barcode = res.data.barcode;
          if(res.data.dad !== null){
                this.dad = res.data.dad.firstname + " " + res.data.dad.lastname
                this.form.dad_id = res.data.dad.id
            }
            else{
            this.dad = "still not assigned"
            }
            if(res.data.mom !== null){
                this.mom = res.data.mom.firstname + " " + res.data.mom.lastname
                this.form.mom_id = res.data.mom.id
          }
          else{
            this.mom = "still not assigned"
          }
          self.loading_info = false;
        }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }else{

        //this.getServiceTypeOnlyActive() //GET SERVICE TYPE ONLY ACTIVE FOR DROPDOWNLIST
        this.getClass() //GET SERVICE TYPE ALL FOR DROPDOWNLIST
        this.getParent() //GET PARENT ACTIVE


        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.id = "";
        self.form.name = "";
      }
    });
  },

  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    queue(){
      this.show = false;
      ikid.queuedKid(this.form)
      .then(res => {
       EventBus.$emit('TABLE_UPDATE', true)
        var params = {title: 'Success', mode:'success', data:res.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    //GET CLASS ALL FOR DROPDOWNLIST
    getClass(){
      this.loading_class = true
      this.options_class = []
      ikid.getIkidClass()
      .then(res => {
        for(let i = 0; i <= res.data.length-1; i++){
          this.options_class.push({text: res.data[i].name, value: res.data[i].id});
        }
      this.loading_class = false
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })   
    },
    // //GET CLASS ONLY ACTIVE FOR DROPDOWNLIST
    // getServiceTypeOnlyActive(){
    //   this.options = []
    //   service.getServiceTypeOnlyActive()
    //   .then(res => {
    //     for(let i = 0; i <= res.data.length-1; i++){
    //       this.options.push({text: res.data[i].name, value: res.data[i].id});
    //     }
    //   }).catch ((err) => {
    //     var params = {title: 'Error', mode:'danger', data:err.message}
    //     EventBus.$emit('OPEN_MODAL_ALERT', params)
    //   })
    // },
    //GET PARENT ACTIVE
    getParent(){
      this.loading_parent = true
      this.options_dad = []
      this.options_mom = []
      ikid.getIkidParent()
      .then(res => {
        for(let i = 0; i <= res.dad.length-1; i++){
          this.options_dad.push({text: res.dad[i].firstname + ' ' + res.dad[i].lastname, value: res.dad[i].id});
        }
        for(let i = 0; i <= res.mom.length-1; i++){
          this.options_mom.push({text: res.mom[i].firstname + ' ' + res.mom[i].lastname, value: res.mom[i].id});
        }
        this.loading_parent = false
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })   
      
    },
  }
}
</script>

<style>
.center {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>